export const ContactNavData = [
  { id: 2, title: "Organization" },
  { id: 3, title: "Follow up" },
  { id: 4, title: "Favorites" },
  { id: 5, title: "Ideas" },
  { id: 6, title: "Important" },
  { id: 7, title: "Business" },
  { id: 8, title: "Holidays" },
];

export const BasicSingleList = [
  { id: 1, value: "pw", text: "Personal web address" },
  { id: 2, value: "cw", text: "Company web address" },
  { id: 3, value: "fb", text: "Fabebook URL" },
  { id: 4, value: "tw", text: "Twitter URL" },
];

export const OrganizationList = [
  {
    id: 1,
    avatar: "user/user.png",
    name: "Mark Jecno",
    email: "MARKJENCOEMAIL",
    gender: "Male",
  },
  {
    id: 2,
    avatar: "user/3.jpg",
    name: "Jason Borne",
    email: "jasonb@gmail.com",
    gender: "Female",
  },
  {
    id: 3,
    avatar: "user/4.jpg",
    name: "Sarah Loren",
    email: "barnes@gmail.com",
    gender: "Female",
  },
  {
    id: 4,
    avatar: "user/10.jpg",
    name: "Andew Jon",
    email: "andewjon@gmail.com",
    gender: "Female",
  },
];

export const DayList = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

export const MonthList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
